<template>
  <v-container fluid fill-height class="d-flex justify-center align-center">
    <!-- Row untuk form login -->
    <v-row justify="center" align="center" class="w-100">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-6" elevation="12">
          <!-- Menambahkan logo di atas form login -->
          <v-img
            src="@/assets/logo-oei-fli-fwi.png"
            alt="Logo"
            height="200px"
            class="mb-4"
            contain
          ></v-img>

          <!-- Form login -->
          <v-form v-model="valid" @submit.prevent="submit">
            <v-text-field
              label="Password"
              v-model="passwordNew"
              :rules="newPasswordRules"
              :type="showPassword ? 'text' : 'password'"
              required
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="togglePasswordVisibility"
            ></v-text-field>

            <v-text-field
              label="Konfirmasi Password"
              v-model="passwordConfirm"
              :rules="confirmPasswordRules"
              :type="showPasswordConfirm ? 'text' : 'password'"
              required
              :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="togglePasswordVisibilityConfirm"
            ></v-text-field>

            <!-- Submit button -->
            <v-btn
              :disabled="!valid"
              type="submit"
              color="primary"
              class="ma-2"
              block
              @click="resetPassword()"
            >
              Submit
            </v-btn>
          </v-form>

          <!-- Snackbar error message -->
          <v-snackbar
            v-model="snackbar"
            color="error"
            top
            multi-line
            timeout="5000"
          >
            {{ errorMessage }}
            <v-btn color="white" @click="snackbar = false">Close</v-btn>
          </v-snackbar>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import axios from "axios";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    snackbarMessage,
  },
  data() {
    return {
      errorMessage: "",
      snackbar: false, // Untuk menampilkan snackbar
      valid: false,
      showPassword: false,
      showPasswordConfirm: false,
      passwordNew: "",
      passwordConfirm: "",
      newPasswordRules: [
        (v) => !!v || "Password Baru required",
        (v) => v.length >= 8 || "Password must be at least 8 characters",
        (v) =>
          /[A-Z]/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /[a-z]/.test(v) ||
          "Password must contain at least one lowercase letter",
        (v) => /[0-9]/.test(v) || "Password must contain at least one number",
        (v) =>
          /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
          "Password must contain at least one special character",
      ],
      confirmPasswordRules: [
        (v) => !!v || "Konfirmasi password diperlukan",
        (v) =>
          v === this.passwordNew || "Password baru dan konfirmasi tidak cocok",
      ],
    };
  },
  methods: {
    resetPassword() {
      const token = this.$route.params.token; // Ambil token dari URL
      const url = `${process.env.VUE_APP_API_URL}/employees/reset-password/${token}`;

      axios
        .post(url, {
          passwordNew: this.passwordNew, // Kirim password baru
        })
        .then((response) => {
          // Ambil pesan dari backend
          const message = response.data.message || "Password reset successful!";

          // Tampilkan snackbar sukses
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });

          // Redirect ke halaman login setelah reset berhasil
          this.$router.push({ name: "login" });
        })
        .catch((error) => {
          console.error("Error during password reset:", error);

          let message = "Failed to reset password!"; // Pesan default
          if (error.response) {
            // Pesan error dari backend (jika ada)
            message = error.response.data.message || message;
          } else {
            // Pesan error fallback
            message = error.message || message;
          }

          // Tampilkan snackbar dengan status error
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        });
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword; // Toggle password visibility
    },
    togglePasswordVisibilityConfirm() {
      this.showPasswordConfirm = !this.showPasswordConfirm; // Toggle password visibility
    },
  },
};
</script>
